import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { User } from '../models/user.model';

@Injectable({
  providedIn: 'root',
})
export class AdminPanelGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    // this.user.roleType === 'admin'
    if (
      this.user?.roleType === 'admin' ||
      this.user?.roleType === 'projectManager' ||
      this.user?.role?.name === 'projectManager' ||
      this.user?.roleType === 'saleManager'
    ) {
      return true;
    }
    this.router.navigate(['/client']);
    return false;
  }

  get user(): User {
    return JSON.parse(localStorage.getItem('user')) || new User();
  }
}
